@for (searchPart of searchParts; track searchPart) {
  @if (searchPart.isEmBlock) {
    <em [class.subtle]="highlightType === 'Subtle'">{{ searchPart.innerText }}</em>
  }
  @if (!searchPart.isEmBlock) {
    {{ searchPart.innerText }}
  }
}
